import { useState, useEffect } from 'react';
import {
    getPartnerUserDetailsApiAddress,
    getPartnerUserDetailsPayload
} from '../utils/partnerUserDetailsServiceUtils';

interface PartnerUserApiResponse {
    isNotSubscribed: boolean;
    [key: string]: any;
}
// interface PartnerUserDetailsPayload {
//     idpType: string;
//     idpMetadata: {
//         version: number;
//         partnerName: string;
//     };
//     idpPayload: {
//         code: string;
//     };
// }

export const useGetPartnerUserDetails = ({
    responseCode
}: {
    responseCode: string;
}) => {
    const [data, setData] = useState<PartnerUserApiResponse | null>(null);
    const [statusCode, setStatusCode] = useState<number | null>(null);
    const [isNotSubscribedUser, setIsNotSubscribedUser] =
        useState<boolean>(false);
    const [isFetchingPartnerUserDetails, setIsFetchingPartnerUserDetails] =
        useState<boolean>(false);
    const isAmazonLp = window.location.href.includes('amazon');

    useEffect(() => {
        if (!responseCode) {
            setData(null);
            return;
        }

        const partnerUserApiPayload = getPartnerUserDetailsPayload(
            responseCode,
            isAmazonLp
        );

        const fetchPartnerUserDetails = async () => {
            setIsFetchingPartnerUserDetails(true);
            try {
                const response = await fetch(
                    getPartnerUserDetailsApiAddress(),
                    partnerUserApiPayload
                );

                setStatusCode(response.status);

                if (response.ok) {
                    const partnerUserJsonData = await response.json();

                    setData(partnerUserJsonData);
                    setIsNotSubscribedUser(
                        partnerUserJsonData.isNotSubscribed || false
                    );
                } else {
                    throw new Error(
                        `Error fetching data: ${response.statusText}`
                    );
                }
            } catch (error) {
                throw error;
            } finally {
                setIsFetchingPartnerUserDetails(false);
            }
        };

        fetchPartnerUserDetails();
    }, [responseCode]);

    return {
        partnerUserData: data,
        isNotSubscribedUser,
        isFetchingPartnerUserDetails,
        statusCode
    };
};
